const tr: any = {
  title: {
    fr: "Popcard Metrics",
    ar: "بوبكارد ميتريكس",
    en: "Popcard Metrics",
  },
  description: {
    fr: "Popcard Metrics vous donne la possibilité de centraliser et suivre toutes les interactions avec vos clients et prospects de manière fluide et efficace à travers les cartes de visite de votre équipe. Notre plateforme vous permet de visualiser en temps réel l'impact de vos actions et de mieux comprendre les besoins et préférences de vos contacts.",
    ar: "يتيح لك Popcard Metrics إمكانية توحيد وتتبع جميع التفاعلات مع عملائك والمحتملين بطريقة سلسة وفعالة من خلال بطاقات الأعمال لفريقك. تتيح لك منصتنا عرض تأثير إجراءاتك في الوقت الفعلي وفهم احتياجات وتفضيلات جهات الاتصال الخاصة بك بشكل أفضل.",
    en: "Popcard Metrics allows you to centralize and track all interactions with your clients and prospects smoothly and effectively through your team’s business cards. Our platform enables you to visualize the impact of your actions in real-time and gain a better understanding of the needs and preferences of your contacts.",
  },
  partageIlimite: {
    fr: "Gestion centralisée des cartes de visite de vos collaborateurs",
    ar: "إدارة مركزية لبطاقات العمل الخاصة بموظفيك",
    en: "Centralized management of your team’s business cards",
  },
  collectIllimite: {
    fr: "Paramétrage et contrôle des infos sur les profils de vos collaborateurs",
    ar: "تهيئة ومراقبة المعلومات على ملفات موظفيك",
    en: "Configuration and control of information on your team profiles",
  },
  editableProfiles: {
    fr: "Suivi et tracking des interactions de vos clients et prospects en temps réel",
    ar: "متابعة وتتبع التفاعلات مع عملائك والمحتملين في الوقت الفعلي",
    en: "Real-time tracking of interactions with your clients and prospects",
  },
  personalize: {
    fr: "Collecte de la base de données clients et prospects",
    ar: "جمع قاعدة بيانات العملاء والمحتملين",
    en: "Collection of client and prospect database",
  },
  kpi: {
    fr: "Cartes de visite personnalisables",
    ar: "بطاقات عمل قابلة للتخصيص",
    en: "Customizable business cards",
  },
  colors: {
    fr: "Colors",
    ar: "الألوان",
    en: "Colors",
  },
  fullName: {
    fr: "Nom et Prénom*",
    ar: "الاسم الكامل *",
    en: "Full Name*",
  },
  enterprise: {
    fr: "Entreprise ou Métier*",
    ar: "الشركة أو الأعمال *",
    en: "Company or Profession*",
  },
  email: {
    fr: "Adresse Email*",
    ar: "البريد الإلكتروني *",
    en: "Email Address*",
  },
  phone: {
    fr: "Téléphone*",
    ar: "الهاتف",
    en: "Phone*",
  },
  address: {
    fr: "Adresse Exacte *",
    ar: "العنوان*",
    en: "Exact Address*",
  },
  city: {
    fr: "Ville *",
    ar: "المدينة *",
    en: "City*",
  },
  qty: {
    fr: "Quantité*",
    ar: "الكمية *",
    en: "Quantity*",
  },
  codePromo: {
    fr: "Code Promo",
    ar: "كوبون",
    en: "Promo Code",
  },
  livraison: {
    fr: "Livraison gratuite partout au maroc",
    ar: "توصيل مجاني في أي مكان في المغرب",
    en: "Free delivery anywhere in Morocco",
  },
  Confirmer: {
    fr: "Confirmer",
    ar: "تأكيد الطلب",
    en: "Confirm",
  },
  mad: {
    fr: "MAD",
    ar: "درهم",
    en: "MAD",
  },
};

export default tr;
